exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn-train {\n  height: 100%;\n  cursor: pointer;\n}\n\n.custom-tooltip {\n  background-color: white;\n  color: #000000;\n  font-size: 125%;\n}", ""]);

